import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import ArticleCard from '@/components/base/ArticleCard';
import { Link } from 'react-router-dom';

export default function FeaturedArticles() {
  const featuredArticles = articles.filter((a) => a.featured).slice(0, 6);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
              精选文章
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              编辑精选的优质内容，助你更好地生活与成长
            </p>
          </div>
          <Link
            to="/category/shequn"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer whitespace-nowrap transition-colors"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article) => {
            const cat = categories.find((c) => c.id === article.category);
            return (
              <ArticleCard
                key={article.id}
                slug={article.slug}
                title={article.title}
                excerpt={article.excerpt}
                category={article.category}
                categoryName={cat?.name || ''}
                author={article.author}
                publishDate={article.publishDate}
                readTime={article.readTime}
                imageUrl={article.imageUrl}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
}